"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearch = void 0;
var _react = require("react");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _useQuestionSelectionActions = require("./useQuestionSelectionActions");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _services = require("../../services");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useSearch = (question, selections) => {
  const minCharacters = question.minCharacters;
  const selection = selections[0];
  const [searchText, setSearchText] = (0, _react.useState)(selection !== null && selection !== void 0 ? selection : '');
  const handsetSearchList = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectHandsetSearchList);
  const {
    replaceSelection,
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const alphaRegex = /[^a-zA-Z0-9\s]/g;
  const onChange = value => {
    setSearchText(value.replace(alphaRegex, ''));
    if (selection) {
      removeSelection(selection);
    }
  };
  const onSelect = choice => {
    if (choice.hasEmptyResults) return;
    replaceSelection(choice.text);
  };
  const onFilter = (value, suggestions) => {
    // keep only alphanumeric and space characters
    const sanitizedValue = value.replace(alphaRegex, '').trim();
    const terms = sanitizedValue.split(' ').filter(term => term !== '');
    const suggestionRankedArray = [];
    terms.forEach(term => {
      //search for every term in the suggestions
      const uniqSuggestions = (0, _lodash.default)(suggestions, suggestion => suggestion.model);
      uniqSuggestions.forEach(suggestion => {
        //is the term included in the model or brand?
        if (suggestion.model.toLowerCase().includes(term.toLowerCase()) || suggestion.brand.toLowerCase().includes(term.toLowerCase())) {
          //yes it is so add it to the suggestion array
          const foundItem = suggestionRankedArray.find(entry => entry.name === suggestion.model);
          //is the suggestion already in the array?
          if (foundItem) {
            //Yes it is increase its score as it matches more terms
            foundItem.score++;
          } else {
            //No, Add it to the array
            suggestionRankedArray.push({
              name: suggestion.model,
              score: 1
            });
          }
        }
      });
    });
    return suggestionRankedArray.length ? suggestionRankedArray.sort((el1, el2) => el2.score - el1.score).map(entry => ({
      text: entry.name
    })) : [{
      text: _services.locale.localeString('ErrorPage.AddressNotFound', {
        value: value
      }),
      hasEmptyResults: true
    }];
  };
  return {
    handsetSearchList,
    searchText,
    minCharacters,
    onChange,
    onSelect,
    onFilter
  };
};
exports.useSearch = useSearch;